export default __webpack_public_path__ + "media/images/user_photos/105-86116d77884235e8817fbe31297a6c4b.jpg";